import axios from 'axios';
import {config} from '../shared/app.config';

const RESOURCE_NAME = '/app/banners';

export default {
  getAllBanners(id) {
    if (id) {
      return axios.post(`${config.webApiBase + RESOURCE_NAME  }/all`, { restaurant_id: id });
    } else {
      return axios.post(`${config.webApiBase + RESOURCE_NAME  }/all`);
    }
  },

  getOne(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME  }/one/${ id }`);
  },

  create(banner) {
      return axios.post(`${config.webApiBase + RESOURCE_NAME}/create`, banner);
  },

  edit(id, banner) {
      return axios.post(`${config.webApiBase + RESOURCE_NAME  }/update/${ id }`, banner);
  },

  delete(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME  }/remove/${ id }`);
  },

  active (id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME  }/active/${  id  }`);
  },
  deactive (id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME  }/disable/${  id  }`);
  }
}
